/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import orderBy from 'lodash.orderby';
import { DashboardTestNewsletter } from 'cio/utils/metrics/models/dashboard-tests';
import { SortDirection } from 'cio/utils/sort';

interface DashboardPageTestsCardNewslettersArgs {
  newsletters: DashboardTestNewsletter[];
  sortByItem: {
    label: string;
    value: string;
    sortBy: string;
    sortDirection: SortDirection;
  };
  trackNavigate: (destination: string) => unknown;
}

export default class DashboardPageTestsNewslettersCard extends Component<DashboardPageTestsCardNewslettersArgs> {
  get sortedNewsletters() {
    return orderBy(this.args.newsletters, [this.args.sortByItem.sortBy], [this.args.sortByItem.sortDirection]);
  }
}
